var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcPlus = function SvgIcPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0Z",
    fill: "#0099FF",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4316 15.1016H16.9316C16.8316 15.1016 16.7616 15.0216 16.7616 14.9316V7.43156C16.7516 6.97156 16.3816 6.60156 15.9316 6.60156C15.4816 6.60156 15.1016 6.97156 15.1016 7.43156V14.9316C15.1016 15.0316 15.0216 15.1016 14.9316 15.1016H7.43156C6.97156 15.1016 6.60156 15.4716 6.60156 15.9316C6.60156 16.3916 6.97156 16.7616 7.43156 16.7616H14.9316C15.0316 16.7616 15.1016 16.8416 15.1016 16.9316V24.4316C15.1016 24.8916 15.4716 25.2616 15.9316 25.2616C16.3916 25.2616 16.7616 24.8916 16.7616 24.4316V16.9316C16.7616 16.8316 16.8416 16.7616 16.9316 16.7616H24.4316C24.8916 16.7616 25.2616 16.3916 25.2616 15.9316C25.2616 15.4716 24.8816 15.1016 24.4316 15.1016Z",
    fill: "#286DF0"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "public/media/ic_plus.7c8f4802.svg";
export { ForwardRef as ReactComponent };